import { useEffect } from "react"

import type { HelpCenterTab } from "@productlane/zero"

import { api } from "@/lib/api"

/** Loads every API reference tab's spec up front, so switching to one renders at once. */
export function usePrefetchApiReferences(
	tabs: readonly Pick<HelpCenterTab, "id" | "kind">[],
) {
	const utils = api.useUtils()
	const tabIds = tabs
		.filter((tab) => tab.kind === "API_REFERENCE")
		.map((tab) => tab.id)
		.join()
	useEffect(() => {
		for (const tabId of tabIds ? tabIds.split(",") : []) {
			void utils.apiReference.get.prefetch({ tabId })
		}
	}, [tabIds, utils])
}
